import React, { useState } from "react";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import BlogService from "../../Service/BlogService";
import "./TauxReussite.css"

const TauxReussite = ({ accueil }) => {
    const [editMode, setEditMode] = useState(false);
    const [tauxReussites, setTauxReussites] = useState(accueil.tauxReussites);
    const [testimonial, setTestimonial] = useState(accueil.commentaires || ""); // Testimonial text
    const [author, setAuthor] = useState(accueil.pseudo || ""); // Testimonial author
    const token = sessionStorage.getItem('token');

    const handleEditClick = () => {
        setEditMode(true);
    };

    const handleInputChange = (field, value) => {
        if (field === "tauxReussites") {
            setTauxReussites(value);
        } else if (field === "testimonial") {
            setTestimonial(value);
        } else if (field === "author") {
            setAuthor(value);
        }
    };

    const handleSaveClick = async () => {
        const updatedAccueil = {
            ...accueil,
            tauxReussites,
            commentaires: testimonial,
            pseudo: author,
        };

        try {
            const response = await BlogService.putAccueil(updatedAccueil);
            console.log(response);
            setEditMode(false);
        } catch (error) {
            console.error("Erreur lors de la sauvegarde :", error);
        }
    };

    return (
        <div className="taux-reussite-section">
            <h2 className="section-title">Taux de réussite</h2>
            <div className="content-container">
                <div className="circular-progress">
                    {editMode ? (
                        <input
                            type="number"
                            value={tauxReussites}
                            onChange={(e) => handleInputChange("tauxReussites", e.target.value)}
                            className="form-control"
                            min="0"
                            max="100"
                            step="1"
                        />
                    ) : (
                        <CircularProgressbar
                            value={parseInt(tauxReussites, 10)}
                            text={`${tauxReussites} %`}
                            styles={buildStyles({
                                textColor: "#000",
                                pathColor: "#ff4d4d",
                                trailColor: "#17203a",
                                textSize: "16px",
                            })}
                        />
                    )}
                </div>
                <div className="testimonial">
                    {editMode ? (
                        <>
                            <textarea
                                value={testimonial}
                                onChange={(e) => handleInputChange("testimonial", e.target.value)}
                                className="form-control mb-2"
                                rows="3"
                                placeholder="Modifier le commentaire"
                            />
                            <input
                                type="text"
                                value={author}
                                onChange={(e) => handleInputChange("author", e.target.value)}
                                className="form-control"
                                placeholder="Modifier l'auteur"
                            />
                        </>
                    ) : (
                        <>
                            <p>{testimonial}</p>
                            <p className="author">{author}</p>
                        </>
                    )}
                </div>
            </div>
            <div className="button-container">
                {editMode ? (
                    <button className="btn btn-success" onClick={handleSaveClick}>
                        Enregistrer
                    </button>
                ) : (token === '' && (
                    <button className="btn btn-danger" onClick={handleEditClick}>
                        Modifier
                    </button>
                ))}
            </div>
        </div>
    );
};

export default TauxReussite;